import api from "@/apis/api"

export const sendAlarmApi = async ({ phone, contents }) => {
  const { data } = await api.post("/api/alarm/send", {
    phone, contents
  })
  return data
}
